import { Routes, Route, Navigate } from 'react-router-dom';
import { MenuPage } from '../pages/Menu';
import { ComandaPage } from '../pages/Comanda';
import { OrderResultPage } from '../pages/Menu/OrderResult';
import { CartRecoveryPage } from '../pages/CartRecovery';

export const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<MenuPage />} />
            <Route path="/comanda" element={<ComandaPage />} />

            {/* Recuperação de carrinho via link do agente de IA */}
            <Route path="/carrinho/:token" element={<CartRecoveryPage />} />

            {/* Rotas de Retorno do Mercado Pago */}
            <Route path="/order-success" element={<OrderResultPage type="success" />} />
            <Route path="/order-failure" element={<OrderResultPage type="failure" />} />
            <Route path="/order-pending" element={<OrderResultPage type="pending" />} />

            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
};
